"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "work-item-ten flex-fill" | "work-item-ten work-two flex-fill" */
    className: string;
    /** Detected variants: "1" | "2" | "3" */
    div0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/icons/work-05.svg" | "/Templates/Doccure/img/icons/work-06.svg" | "/Templates/Doccure/img/icons/work-07.svg" */
    src: string;
    /** Detected variants: "Select Your Service" | "Pick Your Specialist" | "Choose Date & Time" */
    h30Text: ReactNode;
    /** Detected variants: "Choose the type of consultation you need based on your concerns and goals." | "Browse experts and select the doctor who best matches your preferences." | "View available slots and book a time that works best for your schedule." */
    p0Text: ReactNode;
    /** Detected variants: "arrow-down-bg" | "arrow-up-bg" */
    imageWithBasePath0ClassName: string;
    /** Detected variants: "/Templates/Doccure/img/bg/arrow-down.png" | "/Templates/Doccure/img/bg/arrow-up.png" */
    imageWithBasePath0Src: string;
    /** Detected variants: "col-xl-3 col-md-6 d-flex" */
    divClassName?: string;
    /** Detected variants: "work-img" */
    div0ClassName?: string;
    /** Detected variants: "work-icon" */
    div0ClassName2?: string;
    /** Detected variants: "number" */
    div0ClassName3?: string;
    /** Detected variants: "service" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "icon" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid work-01" */
    imageWithBasePath0ClassName3?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/test-01.svg" */
    imageWithBasePath0Src2?: string;
    /** Detected variants: "icon" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid work-02" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/test-02.svg" */
    imageWithBasePath1Src?: string;
    /** Detected variants: "work-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "bg" */
    imageWithBasePath0Alt2?: string;
};
export type HomeTenWorkSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "How It Works" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "A Simple Guide to Your Fertility Journey" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: 4 */
    sectionDiv0Div1Div3Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "service" */
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/work-08.svg" */
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/test-01.svg" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/test-02.svg" */
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Confirm & Attend" */
    sectionDiv0Div1Div3Div0Div1H30H3Text?: ReactNode;
    sectionDiv0Div1Div3Div0Div1H30H3Visible?: boolean;
    sectionDiv0Div1Div3Div0Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div3Div0Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Complete the booking & join your appointment with instant confirmation." */
    sectionDiv0Div1Div3Div0Div1P0PText?: ReactNode;
    workSection36s: WorkSection36sItem[];
    workSection36sItemWrapper?: (item: WorkSection36sItem, content: ReactNode) => ReactNode;
    workSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection36sImageVisible?: boolean;
    workSection36sImageRenderer?: (item: WorkSection36sItem, defaultNode: ReactNode) => ReactNode;
    workSection36sH3Visible?: boolean;
    workSection36sH3Renderer?: (item: WorkSection36sItem, defaultNode: ReactNode) => ReactNode;
    workSection36sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection36sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTenWorkSectionGenerated: FC<HomeTenWorkSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "How It Works",
    sectionDiv0Div0H20H2Text = "A Simple Guide to Your Fertility Journey",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1Div3Div0Div0Div0Div0DivText = 4,
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageAlt = "service",
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/work-08.svg",
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/test-01.svg",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageAlt = "icon",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/test-02.svg",
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div1Div3Div0Div1H30H3Text = "Confirm & Attend",
    sectionDiv0Div1Div3Div0Div1H30H3Visible,
    sectionDiv0Div1Div3Div0Div1H30H3Renderer,
    sectionDiv0Div1Div3Div0Div1H30H3Props,
    sectionDiv0Div1Div3Div0Div1P0PText = "Complete the booking & join your appointment with instant confirmation.",
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath1ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    workSection36s,
    workSection36sItemWrapper,
    workSection36sRenderer,
    workSection36sImageVisible,
    workSection36sImageRenderer,
    workSection36sH3Visible,
    workSection36sH3Renderer,
    workSection36sImageProps,
    workSection36sH3Props,
}) => {
    return (
        <section className="work-section-ten section">
            <div className="container">
                <div className="section-header section-header-ten text-center">
                    <div className="section-sub-title">
                        <span className="sec-circle" aria-hidden="true" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        workSection36s,
                        (item: WorkSection36sItem) => (
                            <div className={item.divClassName ?? "col-xl-3 col-md-6 d-flex"} key={item.key}>
                                <div className={item.className}>
                                    <div className={item.div0ClassName ?? "work-img"}>
                                        <div className={item.div0ClassName2 ?? "work-icon"}>
                                            {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "service"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid"} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                            <div className={item.div0ClassName3 ?? "number"}>{item.div0Text}</div>
                                        </div>
                                        {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath0Src2 ?? "/Templates/Doccure/img/icons/test-01.svg"} alt={item.imageWithBasePath0Alt ?? "icon"} className={item.imageWithBasePath0ClassName3 ?? "img-fluid work-01"} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath1Src ?? "/Templates/Doccure/img/icons/test-02.svg"} alt={item.imageWithBasePath1Alt ?? "icon"} className={item.imageWithBasePath1ClassName ?? "img-fluid work-02"} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath1ImageProps === "function" ? divDiv0Div0ImageWithBasePath1ImageProps(item) : (divDiv0Div0ImageWithBasePath1ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "work-content"}>
                                        {renderItemNode(workSection36sH3Visible, workSection36sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof workSection36sH3Props === "function" ? workSection36sH3Props(item) : (workSection36sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                    {renderItemNode(workSection36sImageVisible, workSection36sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt2 ?? "bg"} className={item.imageWithBasePath0ClassName} {...(typeof workSection36sImageProps === "function" ? workSection36sImageProps(item) : (workSection36sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        workSection36sItemWrapper,
                        workSection36sRenderer
                    )}
                    <div className="col-xl-3 col-md-6 d-flex">
                        <div className="work-item-ten work-two flex-fill">
                            <div className="work-img">
                                <div className="work-icon">
                                    {renderNode(sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div3Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    <div className="number">{sectionDiv0Div1Div3Div0Div0Div0Div0DivText}</div>
                                </div>
                                {renderNode(sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid work-01" {...(sectionDiv0Div1Div3Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid work-02" {...(sectionDiv0Div1Div3Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="work-content">
                                {renderNode(sectionDiv0Div1Div3Div0Div1H30H3Visible, sectionDiv0Div1Div3Div0Div1H30H3Renderer, (
                                    <h3 className="custom-title" {...(sectionDiv0Div1Div3Div0Div1H30H3Props ?? {})}>{sectionDiv0Div1Div3Div0Div1H30H3Text}</h3>
                                ))}
                                <p>{sectionDiv0Div1Div3Div0Div1P0PText}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeTenWorkSectionGenerated;
